import styled from 'styled-components';
import { NavTabsList, NavTabTrigger } from 'ui/tabsGroup';
import { Link } from 'ui/links';
import { fontWeights, spacing } from 'ui/theme';

export const NavTabsListWithoutBorder = styled(NavTabsList)`
  border-bottom: none;
`;

export const LinkNav = styled(Link)`
  align-items: center;
  display: inline-flex;
  border: none;
  gap: ${spacing.half};
  text-decoration: none;
  font-weight: ${fontWeights.bold};
  color: inherit;

  &:hover {
    text-decoration: none;
  }
  &:focus {
    padding-left: 0;
  }
  &:focus::before {
    border: none;
  }
`;

export const HalfGapTrigger = styled(NavTabTrigger)`
  column-gap: ${spacing.half};
`;
